// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from '../DirectMessageBase';
import { Message } from '../Message';
export class TradingWebhookRequestMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_TRADING_WEBHOOK_REQUEST);
        this.name = null;
    }
}
